import { Component, ErrorInfo, ReactNode } from 'react'
import styles from './ErrorBoundary.module.scss'

type Props = {
    children: ReactNode
}

type State = {
    hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(): State {
        return { hasError: true }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo)
    }

    handleReload = () => {
        window.location.reload()
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.container}>
                    <i className="material-icons" style={{ fontSize: '48px', color: '#e74c3c' }}>error_outline</i>
                    <h2>Algo deu errado</h2>
                    <p>Ocorreu um erro inesperado. Tente recarregar a página.</p>
                    <button className={styles.reloadButton} onClick={this.handleReload}>
                        Recarregar Página
                    </button>
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
